import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PromoCard } from "@/components/PromoCards";
import { api } from "@/lib/api";

export default function OffersPage() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/promotions/active").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return (
    <div className="min-h-screen bg-[#F6F8FB]">
      <Navbar />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#0B2454] mb-6" data-testid="offers-title">Προσφορές & ευκαιρίες</h1>
        {items === null ? <p className="text-slate-500">Φόρτωση...</p>
          : items.length === 0 ? <p className="text-slate-500" data-testid="offers-empty">Δεν υπάρχουν ενεργές προσφορές αυτή τη στιγμή.</p>
          : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="offers-grid">
              {items.map((p, i) => <PromoCard key={p.id} promo={p} index={i} />)}
            </div>
          )}
      </main>
      <Footer />
    </div>
  );
}
